import { useRef } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { FaUpload, FaFilePdf, FaFileImage, FaTimes } from 'react-icons/fa';
import '../style/FileUpload.css';

const FileUpload = ({
  label = "Preuve",
  value,
  onChange,
  error,
  accept = ".pdf,.jpg,.jpeg,.png,.doc,.docx",
  maxSizeMB = 10,
  className = ""
}) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    
    if (file) {
      // Validation de la taille
      if (file.size > maxSizeMB * 1024 * 1024) {
        onChange(null, `Le fichier ne doit pas dépasser ${maxSizeMB} MB`);
        return;
      }
      
      // Validation du type
      const acceptedTypes = accept.split(',').map(type => type.trim());
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
      
      if (!acceptedTypes.includes(fileExtension) && !acceptedTypes.includes(file.type)) {
        onChange(null, "Type de fichier non supporté");
        return;
      }
      
      onChange(file, null);
    }
  };

  const handleRemoveFile = () => {
    onChange(null, null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const getFileIcon = (fileName) => {
    if (!fileName) return null;
    
    const extension = fileName.split('.').pop().toLowerCase();
    if (['pdf'].includes(extension)) {
      return <FaFilePdf className="text-danger me-2" />;
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
      return <FaFileImage className="text-success me-2" />;
    }
    return <FaUpload className="text-primary me-2" />;
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div className={`file-upload-component ${className}`}>
      <Form.Group>
        <Form.Label className="fw-semibold">
          {label} <span className="text-danger">*</span>
        </Form.Label>
        
        {!value ? (
          <div 
            className={`file-upload-area border-2 border-dashed rounded p-4 text-center cursor-pointer ${
              error ? 'border-danger bg-danger-light' : 'border-primary bg-light'
            }`}
            onClick={() => fileInputRef.current?.click()}
          >
            <FaUpload size={24} className="text-muted mb-2" />
            <p className="mb-1 text-muted">
              Cliquez pour télécharger ou glissez-déposez un fichier
            </p>
            <small className="text-muted">
              Formats acceptés: PDF, JPG, PNG, DOC (max {maxSizeMB} MB)
            </small>
            
            <Form.Control
              ref={fileInputRef}
              type="file"
              onChange={handleFileChange}
              accept={accept}
              className="d-none"
            />
          </div>
        ) : (
          <div className="file-preview border rounded p-3 bg-light">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                {getFileIcon(value.name)}
                <div>
                  <div className="fw-medium">{value.name}</div>
                  <small className="text-muted">
                    {formatFileSize(value.size)}
                  </small>
                </div>
              </div>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={handleRemoveFile}
                className="ms-2"
              >
                <FaTimes />
              </Button>
            </div>
          </div>
        )}

        {error && (
          <Alert variant="danger" className="mt-2 py-2">
            <small>{error}</small>
          </Alert>
        )}

        <Form.Text className="text text-muted">
          Vous devez ajouter une preuve de transaction (relevé bancaire, confirmation, etc.)
        </Form.Text>
      </Form.Group>
    </div>
  );
};

export default FileUpload;